<template>
	<div>
		<div class="container-fluid p-0"> 
      <div class="row">
        <div class="col-12">     
          <div class="login-card">
            <div>
              <div class="text-center pb-2" style="margin-top:-55px">
                <a class="logo" hidden>
                  <img 
                    class="img-fluid for-light"
                    src="../assets/images/logo/login.png"
                    alt="loginpage"
                  />
                  <img
                    class="img-fluid for-dark"
                    src="../assets/images/logo/logo_dark.png"
                    alt="loginpage"
                  />
                </a>
                <h3 class="txt-primary f-w-600">Rx Fusion <small class="text-muted f-w-500" style="font-size: 1.1rem;color: #a0a0a0 !important;">pro</small> </h3>
            </div>
              <div class="login-main login-form-card"> 
                <form @submit.stop.prevent="signUp" class="theme-form">
                  <h4>Create account</h4>
                  <p>Enter information details to create account</p>
                  <div class="form-group">
                    
                    <div class="form-row">
                      <div class="col-7">
                        <label class="col-form-label pt-0">Business Name</label>
                        <input class="form-control" v-model="cname" type="text" required="" placeholder="Company name">
                      </div>
                      <!-- <div class="col-6">
                        <label class="col-form-label pt-0"> Contact </label>
                        <input class="form-control" v-model="ctel" type="tel" required="" placeholder="XXXXXXXXXX">
                      </div> -->
                      <div class="col-5">
                        <label class="col-form-label pt-0">Business Type </label>
                        <b-form-select v-model="type" class="form-control" :options="typeOptions"></b-form-select>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-form-label"> Email Address</label>
                    <input class="form-control" v-model="cemail" type="email" required="" placeholder="Test@gmail.com">
                    <div class="show-hide"><div hidden style="cursor:pointer" @click="copy" class="txt-primary">use same </div></div>
                  </div>
                  <hr class="my-4">
                  <div class="form-group">
                    <div class="form-row">
                      <div class="col-6">
                        <label class="col-form-label pt-0">Fullname</label>
                        <input class="form-control" v-model="fullname" type="text" required="" placeholder="Fullname">
                      </div>
                      <div class="col-6">
                        <label class="col-form-label pt-0">Contact</label>
                    <input class="form-control" v-model="tel" type="tel" required="" placeholder="XXXXXXXXXX">
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Email Address</label>
                    <input class="form-control" v-model="email" type="email" required="" placeholder="Test@gmail.com">
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Password</label>
                    <input 
                      autocomplete=""
                      class="form-control" 
                      v-model="password" 
                      :type="passwordType" 
                      name="login[password]" 
                      required="" 
                      placeholder="*********" 
                      />
                    <div @click="showPassword" class="show-hide"><span class="show"></span></div>
                  </div>
                  <div class="form-group mb-0">
                    <div class="checkbox p-0">
                      <input id="checkbox1" required type="checkbox">
                      <label class="text-muted f-w-400" for="checkbox1">Agree with <a class="txt-primary" v-b-modal.termsofservice >Terms of service</a> & <a class="txt-primary" v-b-modal.privacy>Privacy Policy</a></label>
                    </div>
                    <button class="btn btn-primary btn-block" type="submit">Create Account</button>
                  </div>
                  
                  <p class="mt-4 mb-0">Already have an account?
                  <router-link class="ml-2" tag="a" to="/auth/login" >
                            Login
                          </router-link>
                  </p>
                </form>
                
                <b-modal size="lg" id="termsofservice">
                    <div>
                      <h2>Terms of service</h2>
                      <p><i>Carefully read information below.</i></p>
                      <br>
                      <p>These terms and conditions outline the rules and regulations for the use of <b class="txt-primary">rxFusion</b> medical platfrom. By accessing this platfrom we assume you accept these terms and conditions in full. Do not continue to use <b class="txt-primary">rxFusion</b>  medical platfrom. if you do not accept all the terms and conditions stated on this page.
                      </p>

                      <p>The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and any or all Agreements: “Client”, “You” and “Your” refers to you, the person accessing this Web Application and accepting the Company’s terms and conditions. “The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to our Company. “Party”, “Parties”, or “Us”, refers to both the Client and ourselves, or either the Client or ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner, whether by formal meetings of a fixed duration, or any other means, for the express purpose of meeting the Client’s needs in respect of provision of the Company’s stated services/products, in accordance with and subject to, prevailing law of Ghana. Any use of the above terminology or other words in the singular, plural, capitalisation and/or he/she or they, are taken as interchangeable and therefore as referring to same.</p>

                      <br>
                      <h3>Cookies</h3>
                      <p>We employ the use of cookies. By using <b class="txt-primary">rxFusion</b> medical platfrom you consent to the use of cookies in accordance with <b class="txt-primary">rxFusion</b>’s privacy policy.Most of the modern day interactive Web Applications use cookies to enable us to retrieve user details for each visit. Cookies are used in some areas of our site to enable the functionality of this area and ease of use for those people visiting. Some of our affiliate / advertising partners may also use cookies</p>

                      <br>
                      <h3>License</h3>
                      <p>
                        Unless otherwise stated, <b class="txt-primary">rxFusion</b> and/or it’s licensors own the intellectual property rights for all material on <b class="txt-primary">rxFusion</b>. All intellectual property rights are reserved. You may view and/or print pages from <b class="txt-primary">https://www.rxfusion.org</b> for your own personal use subject to restrictions set in these terms and conditions.</p>
                      <br>
                      <p>You must not:</p>
                      <ol>
                        <li>Republish material from <b class="txt-primary">https://www.rxfusion.org</b></li>
                        <li>Sell, rent or sub-license material from <b class="txt-primary">https://www.rxfusion.org</b></li>
                        <li>Reproduce, duplicate or copy material from <b class="txt-primary">https://www.rxfusion.org</b></li>
                        <li>Redistribute content from <b class="txt-primary">rxFusion</b>  (unless content is specifically made for redistribution).</li>
                      </ol>
                      <br>

                      <h3>Hyperlinking to our Content</h3>
                      <p>The following organizations may link to our Web Application without prior written approval:</p>
                      <ol>
                        <li>Government agencies;</li>
                        <li>Search engines;</li>
                        <li>News organizations;</li>
                        <li>Online directory distributors when they list us in the directory may link to our Web Application in the same manner as they hyperlink to the Web Applications of other listed businesses; and</li>
                        <li>Systemwide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web Application.</li>
                      </ol>
                      <br>

                      <p>These organizations may link to our home page, to publications or to other Web Application information so long as the link: (a) is not in any way misleading; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party's site.</p>
                      <br>

                      <p>We may consider and approve in our sole discretion other link requests from the following types of organizations: commonly-known consumer and/or business</p>
                      <br>

                      <p>information sources such as Chambers of Commerce, American Automobile Association, AARP and Consumers Union; dot.com community sites; associations or other groups representing charities, including charity giving sites, online directory distributors; internet portals; accounting, law and consulting firms whose primary clients are businesses; and educational institutions and trade associations.</p>
                      <br>

                      <p>We will approve link requests from these organizations if we determine that: (a) the link would not reflect unfavorably on us or our accredited businesses (for example, trade associations or other organizations representing inherently suspect types of business, such as work-at-home opportunities, shall not be allowed to link); (b)the organization does not have an unsatisfactory record with us; (c) the benefit to us from the visibility associated with the hyperlink outweighs the absence of ; and (d) where the link is in the context of general resource information or is otherwise consistent with editorial content in a newsletter or similar product furthering the mission of the organization.</p>
                      <br>

                      <p>These organizations may link to our home page, to publications or to other Web Application information so long as the link: (a) is not in any way misleading; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party's site.</p>
                      <br>

                      
                      <p>If you are among the organizations listed in paragraph 2 above and are interested in linking to our Web Application, you must notify us by sending an e-mail to <a href="mailto:info@rxfusion.org">info@rxfusion.org</a>. Please include your name, your organization name, contact information (such as a phone number and/or e-mail address) as well as the URL of your site, a list of any URLs from which you intend to link to our Web Application, and a list of the URL(s) on our site to which you would like to link. Allow 2-3 weeks for a response.</p>
                      <br>

                      
                      <p>Approved organizations may hyperlink to our Web Application as follows:</p>
                      <br>

                      <ol>
                        <li>By use of our corporate name; or</li>
                        <li>By use of the uniform resource locator (Web address) being linked to; or</li>
                        <li>By use of any other description of our medical Application or material being linked to that makes sense within the context and format of content on the linking party's site.</li>
                        <li>No use of <b class="txt-primary">rxFusion</b>’s logo or other artwork will be allowed for linking absent a trademark license Agreement.</li>
                      </ol>
                      <br>

                      <h3>Iframes</h3>
                      <p>Without prior approval and express written permission, you may not create frames around our Web pages or use other techniques that alter in any way the visual presentation or appearance of our medical Application.</p>
                      <br>

                      <h3>Reservation of Rights</h3>
                      <p>We reserve the right at any time and in its sole discretion to request that you remove all links or any link to our medical Application. You agree to immediately remove all links to our medical Application upon such request. We also reserve the right to amend these terms and conditions and its linking policy at any time. By continuing to link to our medical Application, you agree to be bound to and abide by these linking terms and conditions.</p>
                      <br>
                      
                      <h3>Removal of links from our medical Application</h3>
                      <p>If you find any link on our medical Application or any linked medical Application objectionable for any reason, you may contact us about this. We will consider requests to remove links but will have no obligation to do so or to respond directly to you.</p>
                      <br>
                      <p>Whilst we endeavour to ensure that the information on this medical Application is correct, we do not warrant its completeness or accuracy; nor do we commit to ensuring that the Web Application remains available or that the material on the medical Application is kept up to date.</p>
                      <br>
                      
                      <h3>Content Liability</h3>
                      <p>We shall have no responsibility or liability for any content appearing on your medical Application. You agree to indemnify and defend us against all claims arising out of or based upon your medical Application. No link(s) may appear on any page on your medical Application or within any context containing content or materials that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third-party rights.</p>
                      <br>

                      <h3>Disclaimer</h3>
                      <p>To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our medical Application and the use of this medical Application (including, without limitation, any warranties implied by law in respect of satisfactory quality, fitness for purpose and/or the use of reasonable care and skill). Nothing in this disclaimer will:</p>
                      
                      <ol>
                        <li>limit or exclude our or your liability for death or personal injury resulting from negligence;</li>
                        <li>limit or exclude our or your liability for fraud or fraudulent misrepresentation;</li>
                        <li>limit any of our or your liabilities in any way that is not permitted under applicable law; or</li>
                        <li>exclude any of our or your liabilities that may not be excluded under applicable law.</li>
                      </ol>
                      <br>

                      <p>The limitations and exclusions of liability set out in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer or in relation to the subject matter of this disclaimer, including liabilities arising in contract, in tort (including negligence) and for breach of statutory duty.</p>

                      <p>To the extent that the medical Application and the information and services on the medical Application are provided free of charge, we will not be liable for any loss or damage of any nature.</p>
                      <br>
                      
                      <h3>RxFusion Terms of Use</h3>
                      <p>Credit & Contact Information</p>
                      <br>
                      <p>If you have any queries regarding any of our <b class="txt-primary">Terms of Service</b>, please contact us.</p>
                      
                      <ol>
                        <li>By email: <a href="mailto:contact@rxfusion.org">contact@rxfusion.org</a> </li>
                        <li>By phone number: <a href="tel:233241026572">+233241026572</a> </li>
                        <li>By visiting this page on our website: <a href="https://rxfusionpro.com" >www.rxfusion.org</a></li>
                      </ol>

                    </div>
                </b-modal>

                <b-modal size="lg" id="privacy">
                    <div>
                      <h2>Privacy Policy</h2>
                      <p><i>Carefully read information below.</i></p>
                      <h6>Last updated: <span class="txt-"> February 2<sup>nd</sup>, 2023 </span></h6>
                      <br>
                      <p><b class="txt-primary">rxFusion</b>  ("us", "we", or "our") operates the <b class="txt-primary">www.rxfusion.org</b> website (the "Service"). This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data. We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible from <b class="txt-primary">www.rxfusion.org</b>
                      Information Collection And Use
                      </p>

                      <p>We collect several different types of information for various purposes to provide and improve our Service to you.</p>
                      <br>
                      <h2>Types of Data Collected</h2>
                      <br>

                      <h3>Company Data</h3>
                      <p>While using our Service, we may ask you to provide us with certain company identifiable information that can be used to contact or identify you ("Company Data"). Identifiable information may include, but is not limited to:</p>
                      
                      <ol>
                        <li>Company name</li>
                        <li>Email address</li>
                        <li>Phone number</li>
                        <li>Logo</li>
                        <li>Address</li>
                        <li>Cookies and Usage Data</li>
                      </ol>
                      <br>

                      <h3>Personal Data</h3>
                      <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:</p>
                      
                      <ol>
                        <li>Fullname</li>
                        <li>Email address</li>
                        <li>Phone number</li>
                        <li>Cookies and Usage Data</li>
                      </ol>
                      <br>


                      <h3>Drug Data</h3>
                      <p>While using our Service, we may ask you to provide us with certain drug identifiable information that can identify your drugs ("Drug Data"), <b class="txt-primary">rxFusion</b> offers unlimited drug database for use in account, hence <b class="txt-primary">rxFusion</b> has access to Drug Data for analytics purposes. Patient identifiable information may include, but is not limited to:</p>
                      
                      <ol>
                        <li>Drugname</li>
                        <li>form</li>
                        <li>Strength</li>
                        <li>Unit</li>
                        <li>Description</li>
                      </ol>
                      <br>


                      <h3>Patient Data</h3>
                      <p>While using our Service, we may ask you to provide us with certain patient identifiable information that can identify your patients ("Patient Data"), <b class="txt-primary">rxFusion</b> offers unlimited patient database in your account, hence <b class="txt-primary">rxFusion</b> has access to Patient Data for advertisements and analytics purposes. Patient identifiable information may include, but is not limited to:</p>
                      
                      <ol>
                        <li>Fullname</li>
                        <li>Email address</li>
                        <li>Phone number</li>
                        <li>Gender</li>
                        <li>Date of Birth</li>
                        <li>Address</li>
                        <li>Priscription Data</li>
                        <li>Medication Data</li>
                      </ol>
                      <br>
                      
                      <h3>Usage Data</h3>
                      <p>We may also collect information how the Service is accessed and used ("Usage Data"). This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data. Tracking & Cookies Data</p>

                      <p>We use cookies and similar tracking technologies to track the activity on our Service and hold certain information. Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service. Examples of Cookies we use:</p>

                      <ul>
                        <li>session Cookies. We use Session Cookies to operate our Service.</li>
                        <li>Preference Cookies. We use Preference Cookies to remember your preferences and various settings.</li>
                        <li>Security Cookies. We use Security Cookies for security purposes.</li>
                      </ul>
                      <br>

                      <h3>Use of Data</h3>
                      <p><b class="txt-primary">rxFusion</b> uses the collected data for various purposes:</p>

                      <ol>
                        <li>To provide and maintain the Service</li>
                        <li>To notify you about changes to our Service</li>
                        <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
                        <li>To provide customer care and support</li>
                        <li>To provide analysis or valuable information so that we can improve the Service</li>
                        <li>To monitor the usage of the Service</li>
                        <li>To detect, prevent and address technical issues</li>
                      </ol>
                      <br>

                      <h3>Transfer Of Data</h3>
                      <p>Your information, including Company Data, Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction. If you are located outside Ghana and choose to provide information to us, please note that we transfer the data, including Personal Data, to Germany and process it there. Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.</p>

                      <p><b class="txt-primary">rxFusion</b> will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.</p>
                      <br>

                      <h2>Disclosure Of Data</h2>
                      <br>

                      <h3>Legal Requirements</h3>
                      <p><b class="txt-primary">rxFusion</b> may disclose your Personal Data in the good faith belief that such action is necessary to:</p>

                      <ul>
                        <li>To comply with a legal obligation</li>
                        <li>To protect and defend the rights or property of <b class="txt-primary">rxFusion</b></li>
                        <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
                        <li>To protect the personal safety of users of the Service or the public</li>
                        <li>To protect against legal liability</li>
                      </ul>
                      <br>

                      <h3>Security Of Data</h3>

                      <p>The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security. Service Providers</p>

                      <p>We may employ third party companies and individuals to facilitate our Service ("Service Providers"), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.</p>

                      <p>These third parties have access to your Company Data, Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose. Analytics</p>

                      <p>We may use third-party Service Providers to monitor and analyze the use of our Service.</p>
                      <br>

                      <h3>Google Analytics</h3>

                      <p>Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualize and personalize the ads of its own advertising network.</p>
                      <p>You can opt-out of having made your activity on the Service available to Google Analytics by installing the Google Analytics opt-out browser add-on. The add-on prevents the Google Analytics JavaScript (ga.js, analytics.js, and dc.js) from sharing information with Google Analytics about visits activity.</p>

                      <p>For more information on the privacy practices of Google, please visit the Google Privacy & Terms web page:  <a href="https://policies.google.com/privacy?hl=en" target="_blank">https://policies.google.com/privacy?hl=en</a></p>
                      <br>

                      <h3>Links To Other Sites</h3>

                      <p>Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.</p>

                      <p>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</p>
                      <br>

                      <h3>Children's Privacy</h3>
                      
                      <p>Our Service does not address anyone under the age of 18.</p>
                      <p>We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.</p>
                      <br>

                      <h3>Changes To This Privacy Policy</h3>
                      <p>Posting the new Privacy Policy on this page.</p>
                      <p>We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the "effective date" at the top of this Privacy Policy.</p>
                      <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
                      <br>

                      <h3>Contact Us</h3>

                      <p>If you have any questions about this Privacy Policy, please contact us:</p>
                      
                      <ul>
                        <li>By email: <a href="mailto:contact@rxfusion.org">contact@rxfusion.org</a> </li>
                        <li>By phone number: <a href="tel:233241026572">+233241026572</a> </li>
                        <li>By visiting this page on our website: <a href="https://rxfusionpro.com" >www.rxfusion.org</a></li>
                      </ul>

                    </div>
                </b-modal>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import axios from "axios"

export default {
  name: "login",
  data() {
    return {
      cname: "New Pharmacy Ltd",
      fullname: "Joetag",
      tel: "0203723413",
      type: "",
      email: "jkweku01@gmail.com",
      ctel: this.tel,
      cemail: "",
      password: "lol",
      username: "",
      passwordjwt: "",
      passwordType: "password",
      typeOptions:[
                    { value:"", text: "Select"},
                    { value:"Pharmacy", text: "Pharmacy"},
                    { value:"Hospital", text: "Hospital"},
                    { value:"Clinic", text: "Clinic"},
                    { value:"Other", text: "Other"},
                ],
      submitted: false,
    };
  },
  computed: {
    // JWT authentication
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    },
  },
  created() {
    // reset login status for JWT
    this.$store.dispatch("authentication/logout");
  },
  methods: {
    copy() {
      this.tel = this.ctel
      this.email = this.cemail
    },
    // JWT authentication
    handleSubmit(e) {
      this.submitted = true;
      const { username, passwordjwt } = this;
      const { dispatch } = this.$store;
      if (username && passwordjwt) {
        dispatch("authentication/login", { username, passwordjwt });
      }
      console.log(e)
    },
    // show/hide password
    showPassword: function () {
      if (this.passwordType === "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
    // Firebase login
    signUp: function () {
      this.submitted = true;
      if (this.email == "" && this.password == "") {
        // (this.email = "test@admin.com"), (this.password = "test@123456");
        this.$toasted.show("Oops... all fields are required!", {
                theme: "bubble",
                position: "bottom-right",
                type: "error",
                duration: 2000,
              });
      } else {
        axios.post('/signup', {  cname: this.cname.trim(), ctel: this.ctel, cemail: this.cemail, name: this.fullname.trim(), tel: this.tel , email: this.email, password: this.password })
          .then(
            (result) => {
              // Userauth.localLogin(result.data.user);
              
              this.$swal({
                title:"Congratulations!",
                text: result.data.message,
                type:'success',
              }).then((result)=>{
                if(result.value){
                  // redirect to login
                  this.$router.replace("/auth/login");

                } else {
                  // redirect to login
                  this.$router.replace("/auth/login");
                }
              });
            })
            .catch(
            (err) => {
              // (this.email = "test@admin.com"), (this.password = "test@123456");
              this.$swal({
                title:"Failed!",
                text: err.response.data,
                type:'error'
              });
            }
          );
      }
    },
    
    
  },
};
</script>